import { supabase } from '../utils/supabaseClient'

interface TeamShort {
    team_id: number
    team_club_id: number
    team_club_short_name: string
    team_club_logo: string
    team_club_city: string
    team_club_country: string
}

const fetchTeamsShort = async (): Promise<TeamShort[]> => {
    try {
        console.log('Fetching teams data...');

        const { data: teamsData, error: teamsError } = await supabase
            .from('teams_short')
            .select('*');

        if (teamsError) {
            console.error('Team Error:', teamsError);
            throw teamsError;
        }

        console.log('Teams data', teamsData);

        return teamsData as TeamShort[];
    } catch (error) {
        console.error('Error fetching teams:', error);
        throw error;
    }
};

export default fetchTeamsShort;